import React, { useEffect, useState } from 'react'
import { TableCustom } from '../../components/Table'
import useAxiosInstance from '../../hooks/useAxios';
import { NEWSLETTER_ALL_TRIGGERS_TABLE_KEYS } from '../../helper';
import { useNavigate } from 'react-router-dom';

const AllScheduler = () => {
    const [isLoading,setIsLoading] = useState(false);
    const [triggers,setTriggers] = useState([]);
    const history = useNavigate()
    const axiosInstance = useAxiosInstance();
    useEffect(() => {
          setIsLoading(true);
          axiosInstance
            .get("/newsletter/v2/all_newsletter_triggers/")
            .then((res) => {
              setIsLoading(false);
              let destructuredData = []
              res?.data?.data.forEach(item=>{
                let details_str = ''
                Object.keys(item.time_settings?.meta).forEach(key=>{
                    details_str+=`${key} : ${item.time_settings?.meta?.[key]} `
                })
                destructuredData.push(
                    {...item, 
                        mode:item.time_settings?.mode,
                        time:item.time_settings?.time,
                        date:item.time_settings?.date,
                        extra_details: details_str,
                        analysis_period: item.allowed_configs?.updated_setting?.analysis_period ? item.allowed_configs?.updated_setting?.analysis_period:'default',
                        username : item.allowed_configs?.config?.username,
                        config_id : item.allowed_configs?.config?.pk,
                        original_analysis_period : item.allowed_configs?.config?.meta?.analysis_period,
                        is_other: item?.meta?.is_other,
                        'id':item.pk
                    })
              })
              setTriggers(destructuredData);
            })
            .catch((err) => {
              setIsLoading(false);
            });
      }, []);
      
  return (
    <div className="w-full px-6">
      <p className='text-2xl font-medium mt-5 px-4 py-2 bg-white border rounded-xl'>All Triggers</p>  
      <TableCustom
        columns={NEWSLETTER_ALL_TRIGGERS_TABLE_KEYS}
        data={{'data':triggers}}
        loading={isLoading}
        handleEdit={(id)=>history('/scheduler/edit/'+id)}
        handleDelete={null}
        handleSelect={null}
        className="max-w-full"
    />        
    </div>
  )
}

export default AllScheduler